import LayoutPadrao from 'lg-vue-components/layoutPadrao'

export default [
   {
      path: '/',
      redirect: 'ordem-servico',
      component: LayoutPadrao,
      children: [
         {
            path: '/ordem-servico',
            name: 'ordem-servico',
            component: () => import('./pages/ListarOrdemDeServico.vue')
         }
      ]
   }
]
